export const API_GEO_DATA_URL = `${process.env.REACT_APP_API_GEO_DATA_URL}`
export const API_CORE_URL = `${process.env.REACT_APP_API_CORE_URL}v1/`
export const API_HOUSEHOLD_URL = `${process.env.REACT_APP_API_HOUSEHOLD_URL}v1/`
export const API_MFI_URL = `${process.env.REACT_APP_API_MFI_URL}v1/`
export const API_RPME_URL = `${process.env.REACT_APP_API_RPME_URL}v1/`
export const API_MARKET_URL = `${process.env.REACT_APP_API_MARKET_URL}v1/`
